import style from './style.module.scss';

export default function SubTitle({ content }: { content: string }) {
	return <h2 className={style.subtitle}>{content}</h2>;
}
